<template>
  <div id="slider">
    <v-layout row wrap>
      <v-flex class="label" xs6>
        {{ min }}
      </v-flex>
      <v-flex xs6 class="label" text-xs-right>
        {{ max }}
      </v-flex>
    </v-layout>

    <vue-slider
      ref="slider"
      v-model="period"
      :min="min"
      :max="max"
      height="10"
      tooltip-dir="bottom"
      :process-style="processStyle"
      :slider-style="sliderStyle"
      :tooltip-style="tooltipStyle"
      :lazy="lazy"
      class="mb-4"
    ></vue-slider>
  </div>
</template>

<script>
import vueSlider from "vue-slider-component";
import * as _ from "lodash";

export default {
  name: "Slider",
  components: {
    vueSlider
  },
  props: {},
  data: function() {
    return {
      periodi: [2016, 2018],
      lazy: true,
      processStyle: {
        backgroundColor: "#c47566"
      },
      sliderStyle: [
        { backgroundColor: "#be3117" },
        { backgroundColor: "#be3117" }
      ],
      tooltipStyle: [
        {
          backgroundColor: "transparent",
          borderColor: "transparent",
          color: "#747474",
          "font-size": "11px"
        },
        {
          backgroundColor: "transparent",
          borderColor: "transparent",
          color: "#747474",
          "font-size": "11px"
        }
      ]
    };
  },
  computed: {
    min() {
      return this.$store.state.min;
    },
    max() {
      return this.$store.state.max;
    },
    period: {
      get() {
        return this.$store.state.filters.period;
      },
      set(value) {
        this.$store.commit("setPeriodFilter", value);
      }
    }
  }
};
</script>

<style>
.label {
  font-size: 11px;
  color: #747474;
  font-weight: 900;
  font-family: "Open Sans", sans-serif;
}
</style>
